import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useWorkspace } from 'hooks/useWorkspace';

import closeModalIcon from 'assets/close-modal.svg';

import { fetchProductLibraryAction } from 'Redux/Actions/productLibraryActions';

import AddFlowView from './components/AddFlowView';
import EmptyState from './components/EmptyState';
import FilledState from './components/FilledState';
import LoadingState from './components/LoadingState';

import styles from './styles.module.scss';

const ProductLibraryModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const { selectedWorkspace, isOwner } = useWorkspace();

  const { isEmpty, isLoading, categories } = useSelector(state => state.productLibrary);
  const [showAddFlow, setShowAddFlow] = useState(false);
  const [flowToAddVersion, setFlowToAddVersion] = useState(null);

  useEffect(() => {
    dispatch(fetchProductLibraryAction(selectedWorkspace?.uuid));
  }, [selectedWorkspace?.uuid, dispatch]);

  const handleOpenAddFlow = useCallback(() => {
    setFlowToAddVersion(null);
    setShowAddFlow(true);
  }, []);

  const handleOpenAddVersion = useCallback(flow => {
    setFlowToAddVersion(flow);
    setShowAddFlow(true);
  }, []);

  const handleCloseAddFlow = useCallback(() => {
    setShowAddFlow(false);
    setFlowToAddVersion(null);
  }, []);

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center backdrop-blur-[4px] ${styles.overlay}`}
      onClick={onClose}
    >
      <div
        className={`relative overflow-hidden bg-white rounded-2xl ${styles.modal}`}
        onClick={e => e.stopPropagation()}
      >
        <button
          className={`flex items-center justify-center rounded-full cursor-pointer flex-shrink-0 ${styles.closeButton}`}
          onClick={onClose}
          aria-label="Close product library"
        >
          <img src={closeModalIcon} alt="" width={20} height={20} />
        </button>

        {showAddFlow
          ? (
            <AddFlowView onBack={handleCloseAddFlow} flowToAddVersion={flowToAddVersion} />
          )
          : (
            <>
              {isLoading && <LoadingState />}
              {!isLoading && isEmpty && (
                <EmptyState onAddFlow={isOwner ? handleOpenAddFlow : null} />
              )}
              {!isLoading && !isEmpty && (
                <FilledState
                  categories={categories}
                  onAddFlow={isOwner ? handleOpenAddFlow : null}
                  onAddVersion={isOwner ? handleOpenAddVersion : null}
                />
              )}
            </>
          )}
      </div>
    </div>
  );
};

ProductLibraryModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ProductLibraryModal;
